import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { key: 0 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_container = _resolveComponent("v-container");
    const _component_v_text_field = _resolveComponent("v-text-field");
    const _component_v_icon = _resolveComponent("v-icon");
    const _component_v_tooltip = _resolveComponent("v-tooltip");
    const _component_v_progress_circular = _resolveComponent("v-progress-circular");
    const _component_v_btn = _resolveComponent("v-btn");
    const _component_v_form = _resolveComponent("v-form");
    const _component_v_card = _resolveComponent("v-card");
    return (_openBlock(), _createBlock(_component_v_card, { class: "ma-0" }, {
        default: _withCtx(() => [
            (!_ctx.editLocation.id)
                ? (_openBlock(), _createBlock(_component_v_container, {
                    key: 0,
                    class: "text-h4 text-start"
                }, {
                    default: _withCtx(() => _cache[7] || (_cache[7] = [
                        _createTextVNode(" Neue Location anlegen ")
                    ])),
                    _: 1
                }))
                : _createCommentVNode("", true),
            (_ctx.editLocation.id)
                ? (_openBlock(), _createBlock(_component_v_container, {
                    key: 1,
                    class: "text-h4 text-start"
                }, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.editLocation.internalName), 1)
                    ]),
                    _: 1
                }))
                : _createCommentVNode("", true),
            _createVNode(_component_v_form, { ref: "form" }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_container, { class: "d-flex flex-wrap v-col-12 v-col-lg-6 ml-lg-0" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                                class: "v-col-2 compact",
                                modelValue: _ctx.editLocation.id,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.editLocation.id) = $event)),
                                label: "ID",
                                disabled: "",
                                variant: "outlined",
                                density: "compact"
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_v_text_field, {
                                class: "v-col-10 compact",
                                modelValue: _ctx.editLocation.internalName,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.editLocation.internalName) = $event)),
                                rules: [_ctx.rules.required],
                                label: "Interne Bezeichnung",
                                variant: "outlined",
                                "data-cy": "internalName",
                                density: "compact"
                            }, {
                                "append-inner": _withCtx(() => [
                                    _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                        activator: _withCtx(({ props }) => [
                                            _createVNode(_component_v_icon, _mergeProps(props, {
                                                icon: "mdi-help-circle-outline",
                                                color: "black"
                                            }), null, 16)
                                        ]),
                                        default: _withCtx(() => [
                                            _cache[8] || (_cache[8] = _createTextVNode(" Wird nur intern verwendet, beispielsweise im Einsatz- & Abholplan und sollte daher möglichst kurz sein.")),
                                            _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
                                            _cache[10] || (_cache[10] = _createTextVNode(" Der Kunde bekommt diese Bezeichnung nie zu sehen. "))
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }, 8, ["modelValue", "rules"]),
                            _createVNode(_component_v_text_field, {
                                class: "v-col-12 compact",
                                modelValue: _ctx.editLocation.name,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.editLocation.name) = $event)),
                                rules: [_ctx.rules.required],
                                label: "Name",
                                variant: "outlined",
                                "data-cy": "name",
                                density: "compact"
                            }, {
                                "append-inner": _withCtx(() => [
                                    _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                        activator: _withCtx(({ props }) => [
                                            _createVNode(_component_v_icon, _mergeProps(props, {
                                                icon: "mdi-help-circle-outline",
                                                color: "black"
                                            }), null, 16)
                                        ]),
                                        default: _withCtx(() => [
                                            _cache[11] || (_cache[11] = _createTextVNode(" Name, welcher dem Kunden angezeigt wird. Beispielsweise in der Timeline in den Buchungshinweisen. "))
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }, 8, ["modelValue", "rules"]),
                            _createVNode(_component_v_text_field, {
                                class: "v-col-10 compact",
                                modelValue: _ctx.editLocation.address.street,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.editLocation.address.street) = $event)),
                                rules: [],
                                label: "Straße",
                                variant: "outlined",
                                density: "compact"
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_v_text_field, {
                                class: "v-col-2 compact",
                                modelValue: _ctx.editLocation.address.unitNumber,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.editLocation.address.unitNumber) = $event)),
                                rules: [],
                                label: "Nr",
                                variant: "outlined",
                                density: "compact"
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_v_text_field, {
                                class: "v-col-3 compact",
                                modelValue: _ctx.editLocation.address.postcode,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.editLocation.address.postcode) = $event)),
                                rules: [],
                                label: "PLZ",
                                variant: "outlined",
                                density: "compact"
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_v_text_field, {
                                class: "v-col-9 compact",
                                modelValue: _ctx.editLocation.address.city,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.editLocation.address.city) = $event)),
                                rules: [],
                                label: "Ort",
                                variant: "outlined",
                                density: "compact"
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_v_btn, {
                                onClick: _ctx.save,
                                "data-cy": "save"
                            }, {
                                default: _withCtx(() => [
                                    (!_ctx.saveInFlight)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_1, "Speichern"))
                                        : _createCommentVNode("", true),
                                    (_ctx.saveInFlight)
                                        ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                            key: 1,
                                            indeterminate: "true"
                                        }))
                                        : _createCommentVNode("", true)
                                ]),
                                _: 1
                            }, 8, ["onClick"])
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }, 512)
        ]),
        _: 1
    }));
}
